import { render, staticRenderFns } from "./PaySpecialDiet.vue?vue&type=template&id=002b62d6&scoped=true&"
import script from "./PaySpecialDiet.vue?vue&type=script&lang=js&"
export * from "./PaySpecialDiet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b62d6",
  null
  
)

export default component.exports